
import React, {useEffect, useState} from 'react'
import { Container, Row, Col, Form, Button, Dropdown } from 'react-bootstrap'
import { toast } from "react-toastify";
import { useSelector, useDispatch } from 'react-redux';
import { myBusinessUpdate} from "../../Redux/Settings/myBusiness/actions";

export default function MyBusiness() {
  const dispatch = useDispatch();
  const [validated, setValidated] = useState(false);
  const businessData = useSelector(state => state.myBusinessReducer.data)
  const user = useSelector(state => state.authReducer.data)

  const [formData, setFormData] = useState({
    companyName: businessData?.businessName,
    address: businessData?.overview.address,
    businessPhoneNumber: businessData?.overview.phoneNumber,
    businessEmail: businessData?.overview.email,
    answeringRole: businessData?.role,
    companyDetails: businessData?.overview.businessOverview,
    greeting: businessData?.greetingText,
    customGreeting: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const toastConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
};


  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      toast.error("Please fill all the fields", toastConfig);
    }
    else{

      if(formData.customGreeting !== "") {
        formData.greeting = formData.customGreeting
      }
      const finalPayload = {
          businessName: formData.companyName,
          greetingText: formData.greeting,
          role: formData.answeringRole,
          overview: {
            address: formData.address,
            phoneNumber: formData.businessPhoneNumber,
            email: formData.businessEmail,
            businessOverview: formData.companyDetails,
          },
      };
      await myBusinessUpdate(dispatch, user.accountID, finalPayload)
    }
  };

  const handleRadioChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Container className='mt-5 p-3'>
      <Row style={{overflow:"auto",height:"72vh"}}>
        <Col>
              <div>
                <h4 className='main-h4-tag-large'>Your Business Profile</h4>
                <Form noValidate validated={validated} onSubmit={handleSubmit} className=' w-75'>
                <Form.Group controlId="formName" className='mt-3 custom-p-tag '>
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Company Name"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group controlId="formName" className='mt-3 custom-p-tag'>
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <div className='d-flex'>
                    <Form.Group controlId="formEmail" className='mt-3 custom-p-tag w-50 mr-1'>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter phone number"
                        name="businessPhoneNumber"
                        value={formData.businessPhoneNumber}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group controlId="formName" className='mt-3 custom-p-tag w-50 ml-1'>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter Email"
                        name="businessEmail"
                        value={formData.businessEmail}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </div>
                  <div className='d-flex flex-column'>
                    <Form.Group controlId="formName" className='mt-3 custom-p-tag d-flex flex-column'>
                      <Form.Label>ANSWERING ROLE</Form.Label>
                      <Form.Select aria-label="Default select example" className='p-1' style={{ border: "1px solid #E3E3E3" }}
                        name="answeringRole"
                        value={formData.answeringRole}
                        onChange={handleChange} required>
                        <option>{formData.answeringRole}</option>
                        <option value="Answering Service">Answering Service</option>
                        <option value="Receptionist">Receptionist</option>
                        <option value="Appointment Desk">Appointment Desk</option>
                        <option value="Overflow Center">Overflow Center</option>
                        <option value="Help Desk">Help Desk</option>
                        <option value=" Customer Service"> Customer Service</option>
                        <option value="Customer Care">Customer Care</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                  <Form.Group controlId="formName" className='mt-3 custom-p-tag'>
                    <Form.Label>Explain your business in 2 to 3 sentences</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter Company Details"
                      name="companyDetails"
                      value={formData.companyDetails}
                      onChange={handleChange}
                      required
                      className='pl-2'
                    />
                  </Form.Group>
                  <Form.Group className='mt-3'>
                    <Form.Label className='custom-p-tag'>Greeting Text</Form.Label>
                    <Form.Control
                        type="greetingtext"
                        placeholder="Add default Greeting"
                        name="greetingtext"
                        value={formData.greeting}
                        disabled={true}
                    />

                    <Form.Check
                      type="radio"
                      label={`TYFC ${formData.companyName}. HMIHY?`}
                      name="greeting"
                      value={`TYFC ${formData.companyName}. HMIHY?`}
                      className='ml-3'
                      checked={formData.greeting === `TYFC ${formData.companyName}. HMIHY?`}
                      onChange={handleRadioChange}
                    />
                    <Form.Check
                      type="radio"
                      label={`TYFC ${formData.companyName}. This is ___. HMIHY?`}
                      name="greeting"
                      value={`TYFC ${formData.companyName}. This is ___. HMIHY?`}
                      className='ml-3'
                      checked={formData.greeting === `TYFC ${formData.companyName}. This is ___. HMIHY?`}
                      onChange={handleRadioChange}
                    />
                    <Form.Check
                      type="radio"
                      label="TYFC. HMIHY?"
                      name="greeting"
                      value="TYFC. HMIHY?"
                      className='ml-3'
                      checked={formData.greeting === 'TYFC. HMIHY?'}
                      onChange={handleRadioChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Custom"
                      name="greeting"
                      value="CUSTOM"
                      className='ml-3'
                      checked={formData.greeting === 'CUSTOM'}
                      onChange={handleRadioChange}
                    />
                  </Form.Group>
                  {formData.greeting === "CUSTOM" ?
                  <Form.Group controlId="customGreeting">
                    <Form.Control
                      type="text"
                      name="customGreeting"
                      placeholder="Type your custom greeting"
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>:""}

                  <Button variant="primary" type="submit" className='custom-button mt-4'>
                    Update
                  </Button>
                </Form>
              </div>
        </Col >
      </Row>
    </Container>
  )
}
